export default {
  preferredCommunication: null,
  newPreferredCommunication: null,
  userSlackAuth: null,
  userStartWorkDateUnix: null,
  googleChatAuth: null,
  googleChatSpaceid: null,
  googleId: null
};
